export class MobileResponsiveHelper {
     isChatUsersListSize() {
        return window.screen.availWidth <= 558;
    }
}
